import { render } from "./InvoicePdfStruk.vue?vue&type=template&id=10289ada&scoped=true&ts=true"
import script from "./InvoicePdfStruk.vue?vue&type=script&lang=ts"
export * from "./InvoicePdfStruk.vue?vue&type=script&lang=ts"

import "./InvoicePdfStruk.vue?vue&type=style&index=0&id=10289ada&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10289ada"]])

export default __exports__